import * as Sentry from "@sentry/react";

export const initSentry = () => {
  if (import.meta.env.PROD) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.MODE,
      tracesSampleRate: 0.1,
      beforeSend(event) {
        // Don't send events in development
        if (import.meta.env.DEV) {
          return null;
        }
        return event;
      },
    });
  }
};

export const logAuthError = (error: any, context: Record<string, any> = {}) => {
  console.error('Auth Error:', error, context);
  
  Sentry.withScope((scope) => {
    scope.setTag('error_type', 'authentication');
    scope.setLevel('error');
    
    // Add authentication context
    Object.keys(context).forEach(key => {
      scope.setContext(key, context[key]);
    });
    
    // Add browser/user context
    scope.setContext('auth_debug', {
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      cookies: {
        hasRefreshToken: document.cookie.includes('refresh_token'),
        allCookies: document.cookie.split(';').map(c => c.trim().split('=')[0])
      },
      localStorage: {
        hasCachedUser: !!localStorage.getItem('cached_user'),
        userKeys: Object.keys(localStorage).filter(k => k.includes('user'))
      }
    });
    
    Sentry.captureException(error);
  });
};

export const logAuthEvent = (event: string, data: Record<string, any> = {}) => {
  console.log(`Auth Event: ${event}`, data);
  
  Sentry.addBreadcrumb({
    category: 'auth',
    message: event,
    level: 'info',
    data
  });
};